import { QueryOptions } from '@apollo/client/core';

import apolloClient from '../apollo/apolloClient';
import query from '../apollo/query/getPageBlock.graphql';

interface Block {
  id: string;
  type: string;
  attributes: Record<string, any>[];
}

interface GetPageBlock {
  variables: {
    id: string;
  };
  data: {
    blocks: Block[];
  };
}

const emptyResponse = {
  blocks: [],
};

type ServiceVariables = GetPageBlock['variables'];
type Response = GetPageBlock['data'];

export default class GetPageBlockService {
  private async fetchBlock(variables: ServiceVariables) {
    try {
      const options = Object.assign({ query }, { variables });

      const requestWrapper = async (options: QueryOptions) => {
        const response = await apolloClient.query<Response>(options);
        return response.data;
      };

      const response: Response = await requestWrapper(options);

      return {
        blocks: response.blocks,
      };
    } catch {
      return emptyResponse;
    }
  }

  public async fetch(variables: ServiceVariables) {
    const response = await this.fetchBlock(variables);

    return response;
  }
}
